import type { ProfileCardView } from '@ts-internal/shared-lib';

import type { PublicProfileSearchQuery } from 'src/generated/graphql';

export const mapProfileSearchForDisplay = (
  searchResults: PublicProfileSearchQuery['publicProfileSearch'],
): {
  exactMatchesProfiles: ProfileCardView[];
  partialMatchesProfiles: ProfileCardView[];
  totalExactMatches: number;
  totalPartialMatches: number;
  totalMatches: number;
  serviceToken: string;
} => {
  if (!searchResults) {
    return {
      exactMatchesProfiles: [],
      partialMatchesProfiles: [],
      totalExactMatches: 0,
      totalPartialMatches: 0,
      totalMatches: 0,
      serviceToken: '',
    };
  }

  const { exactMatches, partialMatches, pageInfo, serviceToken } =
    searchResults;

  const exactMatchesProfiles = mapProfileForDisplay(exactMatches, serviceToken);

  const partialMatchesProfiles = mapProfileForDisplay(
    partialMatches,
    serviceToken,
  );

  return {
    exactMatchesProfiles,
    partialMatchesProfiles,
    totalExactMatches: pageInfo.totalExactMatches,
    totalPartialMatches: pageInfo.totalPartialMatches,
    totalMatches: pageInfo.totalMatches,
    serviceToken,
  };
};

type ProfileNode =
  | Array<
      NonNullable<
        PublicProfileSearchQuery['publicProfileSearch']
      >['exactMatches'][number]
    >
  | Array<
      NonNullable<
        PublicProfileSearchQuery['publicProfileSearch']
      >['partialMatches'][number]
    >;

const mapProfileForDisplay = (
  profiles: ProfileNode,
  serviceToken: string,
): ProfileCardView[] => {
  if (!profiles || profiles.length === 0) {
    return [];
  }

  return profiles.map((profile) => ({
    ...profile.node,
    displayName: `${profile.node.firstName} ${profile.node.lastName}`,
    serviceToken,
    homeLocation: profile.node.homeLocation.label ?? '',
    digitalIdentity: {
      isVerified: profile.node.digitalIdentity?.isVerified || false,
      ...(profile.node.digitalIdentity &&
        'verifiedName' in profile.node.digitalIdentity && {
          verifiedName: profile.node.digitalIdentity?.verifiedName || null,
        }),
    },
    workHistories:
      profile.node.workHistories?.map((workHistory) => ({
        companyName: workHistory.companyName,
        roleTitle: workHistory.roleTitle,
        ...('duration' in workHistory && {
          duration: workHistory.duration?.label || undefined,
        }),
        ...('achievements' in workHistory && {
          achievements: workHistory.achievements || undefined,
        }),
      })) || [],
  }));
};
